/* ================================================================
   BONDI WAVE — Shopify Theme JS
   ================================================================ */

(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ── Scroll lock ───────────────────────────────────────────────
     Kept deliberately simple. The lightbox overlay itself has
     overflow-y:auto as a fallback, so even if this doesn't fully
     block background scroll on every mobile browser, the popup can
     never leave the page stuck — the overlay just scrolls instead. */
  function bwLockScroll() { document.body.style.overflow = 'hidden'; }
  function bwUnlockScroll() { document.body.style.overflow = ''; }

  /* ── Fade-up ─────────────────────────────────────────────────── */
  function initFadeUp() {
    const els = qsa('.bw-fade-up');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('is-visible');
      } else {
        io.observe(el);
      }
    });
  }

  /* ── Nav scroll glass ────────────────────────────────────────── */
  function initNav() {
    const nav = qs('#bw-nav');
    if (!nav) return;
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Feature cards rotating highlight ───────────────────────── */
  function initFeatureCards() {
    const cards = qsa('.bw-feature-card');
    if (!cards.length) return;
    let active = 0;
    function highlight(i) { cards.forEach(c => c.classList.remove('is-active')); if (cards[i]) cards[i].classList.add('is-active'); }
    highlight(0);
    setInterval(() => { active = (active + 1) % cards.length; highlight(active); }, 2000);
  }

  /* ── Benefits accordion ──────────────────────────────────────── */
  function initBenefits() {
    qsa('[data-panel-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const bodyId = btn.getAttribute('aria-controls');
        const body = qs('#' + bodyId);
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        qsa('.bw-benefits__panel-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
        qsa('.bw-benefits__panel-body').forEach(b => { b.hidden = true; });
        if (!isOpen) { btn.setAttribute('aria-expanded', 'true'); if (body) body.hidden = false; }
      });
    });
  }

  /* ── How To Apply ────────────────────────────────────────────── */
  function initHowToApply() {
    const playBtn = qs('#bw-how-play');
    const cover = qs('#bw-how-cover');
    const videoWrap = qs('#bw-how-video-wrap');
    const video = qs('#bw-how-video');
    const toggleBtn = qs('#bw-how-video-toggle');
    const pauseIcon = qs('#bw-how-pause');
    const playIcon = qs('#bw-how-play-icon');
    const stepsLeft = qs('#bw-how-steps-left');
    const stepsRight = qs('#bw-how-steps-right');
    const leftImages = qsa('#bw-how-left .bw-how__frame');
    const rightImages = qsa('#bw-how-right .bw-how__frame');
    const steps = qsa('.bw-how__step');
    let activeStep = 0;

    function highlightStep(i) { steps.forEach(s => s.classList.remove('is-active')); if (steps[i]) steps[i].classList.add('is-active'); }
    function startStepCycle() { setInterval(() => { activeStep = (activeStep + 1) % steps.length; highlightStep(activeStep); }, 1500); }

    if (playBtn && video) {
      playBtn.addEventListener('click', () => {
        const frame = qs('#bw-how-video-frame');
        if (frame) frame.classList.add('is-playing');
        if (cover) cover.style.display = 'none';
        if (videoWrap) videoWrap.style.display = 'block';
        leftImages.forEach(f => f.style.display = 'none');
        rightImages.forEach(f => f.style.display = 'none');
        if (stepsLeft) stepsLeft.style.display = 'flex';
        if (stepsRight) stepsRight.style.display = 'flex';
        video.muted = false;
        video.load();
        video.play().catch(() => { video.muted = true; video.play(); });
        highlightStep(0);
        startStepCycle();
      });
    }

    if (toggleBtn && video) {
      toggleBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
          if (pauseIcon) pauseIcon.style.display = '';
          if (playIcon) playIcon.style.display = 'none';
          toggleBtn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          if (pauseIcon) pauseIcon.style.display = 'none';
          if (playIcon) playIcon.style.display = '';
          toggleBtn.setAttribute('aria-label', 'Play video');
        }
      });
    }
  }

  /* ── Infinite Carousel Engine ────────────────────────────────── */
  function createCarousel(viewport, track, opts) {
    opts = Object.assign({ speed: 0.6, onTap: null }, opts);
    const speed = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : opts.speed;
    let offsetRef = 0, halfRef = 0, dragging = false, moved = false;
    let startX = 0, startOffset = 0, hover = false, open = false, raf;

    function computeHalf() {
      const md = window.matchMedia('(min-width: 768px)').matches;
      const sm = window.matchMedia('(min-width: 640px)').matches;
      const cardW = opts.cardWidth ? opts.cardWidth(md, sm) : (md ? 240 : 200);
      const gap = md ? 16 : 12;
      const count = opts.itemCount || Math.floor(track.children.length / 2);
      halfRef = count * (cardW + gap);
    }

    function wrap() {
      if (halfRef <= 0) return;
      if (offsetRef >= halfRef) offsetRef -= halfRef;
      else if (offsetRef < 0) offsetRef += halfRef;
    }

    function tick() {
      if (!dragging && !hover && !open) offsetRef += speed;
      wrap();
      track.style.transform = `translate3d(${-offsetRef}px, 0, 0)`;
      raf = requestAnimationFrame(tick);
    }

    function onWheel(e) {
      if (open) return;
      const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      if (delta === 0) return;
      offsetRef += delta; wrap(); e.preventDefault();
    }

    computeHalf();
    window.addEventListener('resize', computeHalf);
    viewport.addEventListener('wheel', onWheel, { passive: false });
    raf = requestAnimationFrame(tick);

    viewport.addEventListener('pointerdown', e => { dragging = true; moved = false; startX = e.clientX; startOffset = offsetRef; viewport.classList.add('is-dragging'); viewport.setPointerCapture(e.pointerId); });
    viewport.addEventListener('pointermove', e => { if (!dragging) return; const dx = e.clientX - startX; if (Math.abs(dx) > 5) moved = true; offsetRef = startOffset - dx; });
    viewport.addEventListener('pointerup', e => { dragging = false; viewport.classList.remove('is-dragging'); viewport.releasePointerCapture(e.pointerId); if (!moved && opts.onTap) { const el = document.elementFromPoint(e.clientX, e.clientY); opts.onTap(el, e); } });
    viewport.addEventListener('pointercancel', () => { dragging = false; viewport.classList.remove('is-dragging'); });
    viewport.addEventListener('mouseenter', () => { hover = true; });
    viewport.addEventListener('mouseleave', () => { hover = false; });

    return { setOpen(val) { open = val; }, destroy() { cancelAnimationFrame(raf); } };
  }

  /* ── Reviews Carousel + Lightbox ────────────────────────────── */
  function initReviews() {
    const viewport = qs('#bw-reviews-viewport');
    const track = qs('#bw-reviews-track');
    if (!viewport || !track) return;

    const N = track.children.length / 2;
    const lightbox = qs('#bw-review-lightbox');
    const lightboxImg = qs('#bw-review-lightbox-img');
    const closeBtn = qs('#bw-review-lightbox-close');
    const prevBtn = qs('#bw-review-lightbox-prev');
    const nextBtn = qs('#bw-review-lightbox-next');
    let currentIndex = null;

    function openLightbox(i) {
      currentIndex = i % N;
      const cards = qsa('[data-index="' + (i % N) + '"]');
      let src = '';
      for (const card of cards) { const img = qs('img', card); if (img && img.src) { src = img.src; break; } }
      if (lightboxImg) { lightboxImg.src = src; lightboxImg.style.display = src ? '' : 'none'; }
      if (lightbox) { lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false'); }
      carousel.setOpen(true);
      bwLockScroll();
    }

    function closeLightbox() {
      if (lightbox) { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); }
      carousel.setOpen(false);
      bwUnlockScroll();
      currentIndex = null;
    }

    function showPrev() { if (currentIndex === null) return; currentIndex = (currentIndex - 1 + N) % N; openLightbox(currentIndex); }
    function showNext() { if (currentIndex === null) return; currentIndex = (currentIndex + 1) % N; openLightbox(currentIndex); }

    const carousel = createCarousel(viewport, track, {
      speed: 0.6, itemCount: N,
      cardWidth: (md) => md ? 240 : 200,
      onTap(el) { const card = el && el.closest('[data-index]'); if (card) openLightbox(Number(card.getAttribute('data-index'))); }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', showPrev);
    if (nextBtn) nextBtn.addEventListener('click', showNext);
    if (lightbox) lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', e => {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    });
  }

  /* ── Reels Carousel + Lightbox ───────────────────────────────── */
  function initReels() {
    const viewport = qs('#bw-reels-viewport');
    const track = qs('#bw-reels-track');
    if (!viewport || !track) return;

    const reelUrls = window.BW_REELS || {};
    const reels = window.BW_REEL_HANDLES || Object.keys(reelUrls);
    const N = reels.length;
    if (!N) return;

    const lightbox = qs('#bw-reel-lightbox');
    const video = qs('#bw-reel-video');
    const closeBtn = qs('#bw-reel-lightbox-close');
    const prevBtn = qs('#bw-reel-lightbox-prev');
    const nextBtn = qs('#bw-reel-lightbox-next');
    const playToggle = qs('#bw-reel-play-toggle');
    const pauseIcon = qs('#bw-reel-pause-icon');
    const playIcon = qs('#bw-reel-play-icon');
    let currentIndex = null;

    function openLightbox(i) {
      currentIndex = i;
      const handle = reels[i];
      const src = reelUrls[handle] || '';
      const tile = qs('[data-handle="' + handle + '"]');
      const posterSrc = tile ? ((qs('img', tile) || {}).src || '') : '';

      if (video && src) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        if (posterSrc) video.poster = posterSrc;
        video.src = src;
        video.muted = false;
        video.load();
        const tryPlay = () => {
          video.play().catch(() => { video.muted = true; video.play(); });
          if (pauseIcon) pauseIcon.style.display = '';
          if (playIcon) playIcon.style.display = 'none';
        };
        video.addEventListener('canplay', tryPlay, { once: true });
        setTimeout(() => { if (video.paused) tryPlay(); }, 2000);
      }
      if (lightbox) { lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false'); }
      carousel.setOpen(true);
      bwLockScroll();
    }

    function closeLightbox() {
      if (video) { video.pause(); video.src = ''; }
      if (lightbox) { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); }
      carousel.setOpen(false);
      bwUnlockScroll();
      currentIndex = null;
    }

    function showPrev() { if (currentIndex === null) return; currentIndex = (currentIndex - 1 + N) % N; openLightbox(currentIndex); }
    function showNext() { if (currentIndex === null) return; currentIndex = (currentIndex + 1) % N; openLightbox(currentIndex); }

    const carousel = createCarousel(viewport, track, {
      speed: 0.3, itemCount: N,
      cardWidth: (md, sm) => md ? 220 : sm ? 180 : 150,
      onTap(el) {
        const igLink = el && el.closest('[data-ig]');
        if (igLink) { window.open('https://www.instagram.com/' + igLink.getAttribute('data-ig'), '_blank', 'noopener'); return; }
        const tile = el && el.closest('[data-reel-index]');
        if (tile) openLightbox(Number(tile.getAttribute('data-reel-index')));
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', showPrev);
    if (nextBtn) nextBtn.addEventListener('click', showNext);
    if (lightbox) lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });

    if (playToggle && video) {
      playToggle.addEventListener('click', e => {
        e.stopPropagation();
        if (video.paused) {
          video.play().catch(() => {});
          if (pauseIcon) pauseIcon.style.display = '';
          if (playIcon) playIcon.style.display = 'none';
          playToggle.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          if (pauseIcon) pauseIcon.style.display = 'none';
          if (playIcon) playIcon.style.display = '';
          playToggle.setAttribute('aria-label', 'Play video');
        }
      });
    }

    document.addEventListener('keydown', e => {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    });

    qsa('[data-lazy-video]').forEach(v => {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); });
      }, { threshold: 0.1 });
      io.observe(v);
    });
  }

  /* ── FAQ Accordion + Show More ───────────────────────────────── */
  function initFAQ() {
    qsa('.bw-faq__trigger').forEach(btn => {
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        const body = qs('#' + btn.getAttribute('aria-controls'));
        qsa('.bw-faq__trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
        qsa('.bw-faq__answer').forEach(b => { b.hidden = true; });
        if (!isOpen) { btn.setAttribute('aria-expanded', 'true'); if (body) body.hidden = false; }
      });
    });
    const moreBtn = qs('#bw-faq-more');
    if (moreBtn) {
      moreBtn.addEventListener('click', () => {
        qsa('.bw-faq__item--hidden').forEach(el => el.classList.add('is-visible'));
        moreBtn.classList.add('is-hidden');
      });
    }
  }

  /* ── Count-up animation ──────────────────────────────────────── */
  function initCountUp() {
    const els = qsa('[data-countup]');
    if (!els.length) return;

    function animateCountUp(el, end, duration, decimals) {
      decimals = decimals || 0;
      const start = performance.now();
      const isFloat = decimals > 0;
      const update = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const val = eased * end;
        el.textContent = '$' + (isFloat ? val.toFixed(decimals) : Math.round(val));
        if (progress < 1) requestAnimationFrame(update);
      };
      requestAnimationFrame(update);
    }

    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const raw = e.target.getAttribute('data-countup');
          const end = parseFloat(raw);
          const forcedDecimals = e.target.getAttribute('data-decimals');
          const decimals = forcedDecimals ? parseInt(forcedDecimals) : (raw.split('.')[1] || '').length;
          animateCountUp(e.target, end, 1200, decimals);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });

    els.forEach(el => io.observe(el));
  }

  /* ── Email signup validation ─────────────────────────────────── */
  function initEmailSignup() {
    const form = qs('#bw-signup-form');
    const input = qs('#bw-email-input');
    if (!form || !input) return;
    form.addEventListener('submit', e => {
      if (!input.value || !input.value.includes('@')) {
        e.preventDefault();
        input.style.borderBottomColor = '#ff453a';
        input.focus();
        setTimeout(() => { input.style.borderBottomColor = ''; }, 2000);
      }
    });
  }

  /* ── Init ────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initFadeUp();
    initNav();
    initFeatureCards();
    initBenefits();
    initHowToApply();
    initReviews();
    initReels();
    initFAQ();
    initCountUp();
    initEmailSignup();
  });

})();
